module.exports = __webpack_public_path__ + "static/media/404.90636090.png";